<template>
  <div class="achievementCard" @click="$router.push('/studyResult/detail?id=' + encodeURIComponent(data.Id) + '&type=apply')">
    <p class="preview">{{data.Brief}}</p>
    <div>
      <p class="date">{{this.$utils.timeResult(data.AdminSetTime).day}}</p>
      <p class="month">{{this.$utils.timeResult(data.AdminSetTime).year}}.{{this.$utils.timeResult(data.AdminSetTime).month}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "achievementCard",
  props: {
    // {id: '', brief: '', AdminSetTime}
    data: {
      type: Object
    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.achievementCard {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  height: 400px;
  padding: 25px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.35);
  transition: .15s;
  cursor: pointer;
  &:hover {
    border: 1px solid #d7d7d7;
    border-radius: 3px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  }
  div {
    text-align: right;
  }
}
.preview {
  flex: 1;
  font-size: 16px;
  color: #c5c5c7;
  text-align: justify;
  text-justify: inter-word;
  @include hideTextOverflow;
  line-height: 32px;
  white-space: normal;
  transition: .2s;
}
.date {
  font-weight: bold;
  font-style: normal;
  font-size: 28px;
  color: #7f7f7f;
  line-height: 24px;
}
.month {
  color: #7f7f7f;
  line-height: 24px;
}
</style>
